<template>
	<div class="payment_section_card_container">
	  <div class="title_wrapper heading_8">{{ title }}</div>
	  <div>
		<slot></slot>
	  </div>
	</div>
  </template>

  <script>
  export default {
	props: {
	  title: {
		type: String,
		required: true
	  },
	  titleAdditionalButton: {
		type: String
	  },
	  onTitleAdditionalButtonClick: {
		type: Function
	  }
	},
	methods: {
	  handleTitleAdditionalButtonClick () {
		this.onTitleAdditionalButtonClick()
	  }
	}
  }
  </script>

  <style scoped>
  .payment_section_card_container {
	padding: 24px 20px;
	border-bottom: 10px solid var(--gray-scale-10);
  }
  .payment_section_card_container > .title_wrapper {
	margin-bottom: 24px;
  }
  .payment_section_card_container > .title_wrapper  > button{
	display: flex;
	align-items: center;
  }
  </style>



// WEBPACK FOOTER //
// src/components/ai/card/PaymentSectionCard.vue